import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetCurrency } from "../service";

export const useGetCurrency = ({ options }) => {
  return useQuery(
    [queryKey.CURRENCY_LIST],
    () =>
      apiGetCurrency().then((res) => {
        const currencyList = [];
        res.data.data?.map((item) => {
          currencyList.push({ label: item?.currency, value: item?.currency });
        });
        return currencyList;
      }),
    {
      ...options,
    },
  );
};
